import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sidemenu from '../../components/sidemenu';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Pagination from '../../components/pagination';
import Confirmation from '../../components/confirmation';
import Dropdown from '../../components/elements/dropdown01';
import MoreDropDown from '../../components/elements/moreDropDown';
import * as Styled from './styled';

// import search from '../../images/search.svg';
// import deleteIcon from '../../images/delete.svg';
// import publicIcon from '../../images/eye.svg';
import editIcon from '../../images/edit.svg';
import clockIcon from '../../images/clock-9.svg';
import userIcon from '../../images/user.svg';
import questionIcon from '../../images/help-circle.svg';
import marksIcon from '../../images/check-circle.svg';
import testImage from '../../images/test-image.png';

import { filterRequest } from '../assessmentQuestion/actions';
import { testRequest, deleteRequest, visibilityRequest } from './actions';

class AssessmentTest extends Component {
  constructor (props) {
    super(props)
    this.state = {
      page: 1,
      entries: 10,
      mode: 'add',
      confirmation: false,
      difficulty: [
        { id: 'EASY', title: 'Easy' },
        { id: 'MEDIUM', title: 'Medium' },
        { id: 'HARD', title: 'Hard' },
      ],
      owners: [
        { id: 'COFFEEE', title: 'Coffeee' },
        { id: 'BOOTCAMP', title: 'Bootcamp' },
        { id: 'RECRUITER', title: 'Recruiter' },
        {id:'CAMPAIGN', title: 'campaign'},
        { id: 'COFFEEEPLUS', title: 'Coffeee Plus' },
        { id: 'CONTESTPLUS', title: 'Contest Plus' }
      ],
      testTypes: [
        { id: null, title: 'All' },
        { id: 'PUBLIC', title: 'Public' },
        { id: 'PRIVATE', title: 'Private' },
      ],
      moreList: [
        {title: 'Attempt Test'},
        // {title: 'Publish'},
        {title: 'Duplicate'}
      ],
      filters: {
        test_type: 'PUBLIC'
      },
      visibility: {},
    }
  }

  UNSAFE_componentWillMount() {
    this.props.testRequest();
    this.props.filterRequest();
  }

  dateFormat = (dateString) => {
    if (typeof dateString !== 'undefined' && dateString !== null && dateString !== '') {
      const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const createdDate = new Date(dateString);

      const day = createdDate.getDate();
      const month = createdDate.getMonth();
      const year = createdDate.getFullYear();
      let hours = createdDate.getHours();
      let minutes = createdDate.getMinutes();

      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12;
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;

      return `${day} ${monthNames[month]} ${year}, ${hours}:${minutes} ${ampm}`;
    }
  }

  filterSelect = (id, name) => {
    const filters = this.state.filters;
    if (typeof id !== 'undefined' && id !== '') {
      filters[name] = id;
    } else {
      delete filters[name];
    }
    this.props.testRequest(filters);
    this.setState({ filters });
  }

  deleteTest = (id) => {
    this.setState({ id, confirmation: true });
  }

  closeConfirmation = () => {
    this.setState({ confirmation: false });
  }

  changeVisibility = (e, i, id) => {
    const visibility = {};
    visibility.id = id;
    visibility.isChecked = e.target.checked;
    visibility.index = i;
    this.setState({ visibility, confirmation: true });
  }

  confirmVisibility = () => {
    if (this.props.assessmentTest
    && this.props.assessmentTest.tests
    && this.props.assessmentTest.tests.length > 0
    && this.state.visibility) {
      const tests = this.props.assessmentTest.tests;
      const visibility = this.state.visibility;
      tests[visibility.index].active = visibility.isChecked;
      this.props.visibilityRequest(tests, visibility.id, visibility.isChecked, this.state.filters);
    }
    this.setState({ confirmation: false, visibility: {} });
  }

  confirmDelete = () => {
    const id = this.state.id;
    this.props.deleteRequest(id, this.state.filters);
    this.setState({ confirmation: false, id: '' })
  }

  render () {
    const { page, entries, moreList, filters, difficulty, owners, testTypes, confirmation } = this.state;
    const { filter } = this.props.assessmentQuestion;
    const { tests } = this.props.assessmentTest;
    return (
      <Styled.MainDiv>
        <Confirmation show={confirmation} heading="Would you like to change visibility?" type="confirm" close={this.closeConfirmation} confirm={this.confirmVisibility} buttonText="Change" />
        <Sidemenu collapsed={this.state.sideMenuCollapsed} />
        <Styled.ColumnDiv>
          <Header />

          <Styled.ContentWrapDiv>
            <Styled.ContentDiv>
              <Styled.HeaderWrapDiv>
                <div>All Tests</div>
                <Styled.AddLink to="/assessment-test/add"><span>+</span>Add Test</Styled.AddLink>
              </Styled.HeaderWrapDiv>

              <div style={{ minHeight: '58px' }}>
                { typeof filter !== 'undefined' ?
                  <Styled.FilterWrapDiv>
                    <Dropdown title="Skills" list={filter.category} value="id" name="master_skill_id" selected={this.filterSelect} width="180px" option="category_name" active={filters} addAll />
                    <Dropdown title="Difficulty" list={difficulty} value="id" name="level" selected={this.filterSelect} width="180px" option="title" active={filters} addAll />
                    <Dropdown title="Type" list={testTypes} value="id" name="test_type" selected={this.filterSelect} width="180px" option="title" active={filters} />
                    <Dropdown title="Owners" list={owners} value="id" name="owners" selected={this.filterSelect} width="180px" option="title" active={filters} addAll />
                    {/* <Styled.SearchDiv>
                      <img src={search} alt="search" />
                      <input type="text" placeholder="Search" />
                    </Styled.SearchDiv> */}
                  </Styled.FilterWrapDiv>
                : ''
                }
              </div>

              <Styled.CardDiv>
                { tests && tests.map((t, tIndex) => (
                  <Styled.TestWrapDiv>
                    <Styled.TestImage
                      src={t.test_cover_img}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src=testImage;
                      }}
                      alt="test"
                    />
                    <Styled.TestColumnDiv style={{ minWidth: '0', margin: '0px 20px' }}>
                      <Styled.TestHeadingP>{t.test_title}</Styled.TestHeadingP>
                      <Styled.TestInfoWrapDiv>
                        <div><img src={clockIcon} alt="time" />{`${t.duration} Minutes`}</div>
                        <div><img src={userIcon} alt="attempt" />1.3K</div>
                        <div><img src={questionIcon} alt="questions" />{t.total_questions}</div>
                        <div><img src={marksIcon} alt="marks" />{t.total_marks}</div>
                      </Styled.TestInfoWrapDiv>
                      <Styled.TestSwitchDiv>
                        <Styled.SwitchLabel><input type="checkbox" checked={t.test_type === 'PUBLIC' ? true : false} /><span /></Styled.SwitchLabel>
                        Public
                      </Styled.TestSwitchDiv>
                    </Styled.TestColumnDiv>

                    <Styled.TestColumnDiv style={{ alignItems: 'flex-end', marginLeft: 'auto', flexShrink: '0' }}>
                      <Styled.TestUpdateDiv>{`Last update: ${this.dateFormat(t.created_at)}`}</Styled.TestUpdateDiv>
                      <Styled.TestActionWrapDiv>
                        {/* <Styled.ActionButton>
                          <img src={publicIcon} alt="is public" title="Visibility" />
                        </Styled.ActionButton> */}
                        <Styled.ActionLink to={`/assessment-test/edit/${t.test_id}`}>
                          <img src={editIcon} alt="edit" title="Edit Test" />
                        </Styled.ActionLink>
                        {/* <Styled.ActionButton onClick={() => this.deleteTest(t.test_id)}>
                          <img src={deleteIcon} alt="delete" title="Delete Test" />
                        </Styled.ActionButton> */}
                        <MoreDropDown list={moreList} option="title" width="140px" test_id={t.test_id} />
                      </Styled.TestActionWrapDiv>
                      <Styled.TestSwitchDiv>
                        <Styled.SwitchLabel><input type="checkbox" checked={t.active} onChange={(e) => this.changeVisibility(e, tIndex, t.test_id)}/><span /></Styled.SwitchLabel>
                        Visibility
                      </Styled.TestSwitchDiv>
                    </Styled.TestColumnDiv>
                  </Styled.TestWrapDiv>
                )) }
              </Styled.CardDiv>

              { tests && tests.length > entries ?
                <Pagination
                  count={tests.length}
                  entries={entries}
                  currentPage={page}
                  paginationClick={this.paginationClick}
                />
              : <div />
              }

            </Styled.ContentDiv>

            <Footer />
          </Styled.ContentWrapDiv>

        </Styled.ColumnDiv>
      </Styled.MainDiv>
    )
  }
}

const mapStateToProps = state => ({
  assessmentTest: state.assessmentTest,
  assessmentQuestion: state.assessmentQuestion
})

const mapDispatchToProps = {
  testRequest,
  filterRequest,
  deleteRequest,
  visibilityRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(AssessmentTest)
